module.exports = __webpack_public_path__ + "img/W7009-tran.f0e1c6ba.jpg";